// extracted by mini-css-extract-plugin
export default {"title":"styles_title__adr2p","item":"styles_item__NmlL2","imageWrapper":"styles_imageWrapper__jef-f"};